'use client'

import { useNetworkStore } from '@/store/networkStore'

export function useNetworkStatus() {
  const networkStatus = useNetworkStore((state) => state.networkStatus)
  return { isOffline: networkStatus.isOffline, networkStatus }
}
